import Card from "components/card";
import { ACTIVATION_TYPES } from "utils/constants";
import { formatPrice } from "utils/price";

const CardDx = ({ state }) => {
    return (
        <Card extra={"w-full p-4 sm:overflow-x-auto"}>
            <div className="relative mb-8 flex items-center">
                <div className="w-full text-2xl font-bold text-gray-800 dark:text-white">
                    Riepilogo Richiesta
                </div>
            </div>

            {state.data.licenses.length > 0 ? (
                <div className="flex flex-wrap">
                    <div className="w-full">
                        {state.data.licenses.map((license, index) => {
                            if (license.active) {
                                return (
                                    <div
                                        className="mb-6"
                                        key={"licensesactivated" + license.code}
                                    >
                                        <span className="text-sm font-medium text-gray-800">
                                            {license.name}{" "}
                                            {license.mode === "select"
                                                ? license.qty
                                                : ""}
                                        </span>
                                        <div className="flex justify-between">
                                            <div className="w-w-full md:w-1/2">
                                                <span className="text-sm font-medium text-gray-600">
                                                    {license.code !== "cluster"
                                                        ? license.code !==
                                                              "ssl" &&
                                                          license.mode !==
                                                              "select"
                                                            ? license.qty +
                                                              " x € " +
                                                              formatPrice(
                                                                  license.price
                                                              )
                                                            : ""
                                                        : "+ " +
                                                          parseFloat(
                                                              license.price
                                                          ) *
                                                              100 +
                                                          "%"}
                                                </span>
                                            </div>
                                            <div className="flex w-full justify-end md:w-1/2">
                                                <span className="text-sm font-semibold text-gray-800">
                                                    {license.code !== "cluster"
                                                        ? "€ " +
                                                          formatPrice(
                                                              license.total
                                                          )
                                                        : "già calcolata"}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                );
                            }
                        })}
                        {state?.data?.maintenance !== undefined &&
                        state.type === ACTIVATION_TYPES.ONSITE ? (
                            <div className="mb-6" key={"maintenancetype"}>
                                <span className="text-sm font-medium text-gray-800">
                                    Maintenance
                                </span>
                                <div className="flex justify-between">
                                    <div className="w-w-full md:w-1/2">
                                        <span className="text-sm font-medium text-gray-600"></span>
                                    </div>
                                    <div className="flex w-full justify-end md:w-1/2">
                                        <span className="text-sm font-semibold text-gray-800">
                                            {"€ " +
                                                formatPrice(
                                                    state.data
                                                        ?.maintenance_data[
                                                        state?.data?.maintenance
                                                            ? state?.data
                                                                  ?.maintenance
                                                            : 0
                                                    ]?.price
                                                )}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        ) : null}
                    </div>
                </div>
            ) : null}

            <div className="-mx-4 -mb-4 flex flex-wrap bg-gray-200 py-6">
                <div className="flex w-full justify-between px-4">
                    <div className="w-full md:w-1/2">
                        <span className="text-base font-bold text-gray-800">
                            Totale:
                        </span>
                    </div>
                    <div className="flex w-full justify-end md:w-1/2">
                        <span className="text-right text-base font-bold text-gray-800">
                            €{" "}
                            {state.data.total
                                ? formatPrice(state?.data?.total)
                                : 0}
                        </span>
                    </div>
                </div>
            </div>
        </Card>
    );
};

export default CardDx;
